export const ServicesBox = [

    {
        id: "crop-spraying",
        src: "https://mhagrotech.com/Media/Services/New/crop-spraying.webp",
        title: "Crop Spraying",
        description: "MH AgroTech delivers precision drone spraying for pesticides, herbicides, and fertilizers ensuring uniform coverage, up to 30% chemical savings, lower labour costs, and healthier crops with minimal environmental impact.",
    },
    {
        id: "field-seeding",
        src: "https://mhagrotech.com/Media/Services/New/field-seeding.webp",
        title: "Field Seeding",
        description: "MH AgroTech delivers precision drone seeding that ensures fast, uniform, and accurate seed placement across any terrain. Our technology reduces labour, minimizes seed wastage, and boosts germination for higher yield potential ideal for large or hard-to-reach fields.",
    },
    {
        id: "smart-crop-health-and-protection",
        src: "https://mhagrotech.com/Media/Services/New/smart-crop-health and-protection.webp",
        title: "Smart Crop Health and Protection",
        description: "MH AgroTech uses AI-powered drones with multispectral sensors to detect pests, diseases, and nutrient deficiencies early. Farmers get real-time insights to take quick action, improve yields, and reduce unnecessary pesticide use.",
    },
    {
        id: "precision-land-mapping",
        src: "https://mhagrotech.com/Media/Services/New/precision-land-mapping.webp",
        title: "Precision Land Mapping",
        description: "MH AgroTech provides high-accuracy field and land mapping with 3D terrain modelling to support better field planning, irrigation design, drainage management, and efficient land utilization using fast, cost-effective drone surveys.",
    },
    {
        id: "digital-soil-intelligence",
        src: "https://mhagrotech.com/Media/Services/New/digital-soil-intelligence.webp",
        title: "Digital Soil Intelligence",
        description: "MH AgroTech delivers data-driven soil health reports including NPK levels, micronutrients, pH, and fertility insights, enabling precise fertilizer planning, reduced input wastage, improved soil health, and sustainable crop productivity.",
    },
    {
        id: "irrigation-and-water-stress-analysis",
        src: "https://mhagrotech.com/Media/Services/New/irrigation-and-water-stress-analysis.webp",
        title: "Irrigation & Water Stress Analysis",
        description: "Our drones use thermal imaging to detect over- and under-irrigated zones, helping farmers optimize water usage. This ensures healthier crops, reduces water waste, and improves irrigation efficiency across the farm.",
    },
    {
        id: "farm-surveillance",
        src: "https://mhagrotech.com/Media/Services/New/farm-surveillance-camera-based.webp",
        title: "Farm Surveillance",
        description: "MH AgroTech offers 24/7 camera-based farm security with night vision, motion alerts, and remote live monitoring. Farmers get instant alerts for intrusions, equipment faults, or unusual activity reducing losses and ensuring peace of mind.",
    },
    {
        id: "agri-land-recovery",
        src: "https://mhagrotech.com/Media/Services/New/agri-land-restoration.webp",
        title: "Agri Land Recovery",
        description: "MH AgroTech offers post-disaster land recovery services using drone-based assessment to restore agricultural land affected by floods, landslides, and erosion, supporting soil rehabilitation, drainage correction, and safe return to cultivation.",
    },
    {
        id: "solar-panel-cleaning",
        src: "https://mhagrotech.com/Media/Services/New/solar-panel-cleaning.webp",
        title: "Solar Panel Cleaning",
        description: "MH AgroTech provides safe and efficient drone-assisted solar panel cleaning that removes dust and debris, improves energy output, reduces maintenance risks, and ensures consistent performance for large and hard-to-access solar installations.",
    },
    // {
    //     id: "farm-surveillance-camera-based",
    //     src: "https://mhagrotech.com/Media/Services/New/farm-surveillance-camera-based.webp",
    //     title: "Farm Surveillance (Camera-Based)",
    //     description: "MH AgroTech offers 24/7 camera-based farm security with night vision, motion alerts, and remote live monitoring. Farmers get instant alerts for intrusions, equipment faults, or unusual activity reducing losses and ensuring peace of mind.",
    // },
    // {
    //     id: "carbon-and-sustainability-monitoring",
    //     src: "https://mhagrotech.com/Media/Services/New/carbon-and-sustainability-monitoring.webp",
    //     title: "Carbon & Sustainability Monitoring",
    //     description: "We use drone-based environmental sensors to track farm carbon footprints and sustainability performance. Farmers receive clear insights and actionable steps to reduce emissions, optimize resources, and support eco-friendly agriculture",
    // },

]